export const numberWithCommas = (x) => {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

export const formatPhoneNumber = (value) => {
  if (value === null || value === undefined) {
    return "";
  } else {
    let onlyNumbers = value.replace(/[^0-9]/g, "");
    let numberArray = onlyNumbers.split("");
    if (numberArray.length > 9) {
      let formatedNumber =
        "(" +
        numberArray[0] +
        numberArray[1] +
        numberArray[2] +
        ") " +
        numberArray[3] +
        numberArray[4] +
        numberArray[5] +
        "-" +
        numberArray[6] +
        numberArray[7] +
        numberArray[8] +
        numberArray[9];
      return formatedNumber;
    } else {
      return value;
    }
  }
};
